import { render, staticRenderFns } from "./EvacuationPathTable.vue?vue&type=template&id=629f5269"
import script from "./EvacuationPathTable.vue?vue&type=script&lang=js"
export * from "./EvacuationPathTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports